import React from 'react';
import PropTypes from "prop-types";

const VoidState = (props) => {
    const {message, classes} = props;

    return (
        <div className={classes}>
            <div className="empty d-flex h-100 py-3">
                <p className="h5 text-uppercase font-weight-bold mx-auto align-self-center">
                    <span className="icon error-data mr-3"/> {message}
                </p>
            </div>
        </div>
    )
}

VoidState.propTypes = {
    message: PropTypes.string,
    classes: PropTypes.string,
}

VoidState.defaultProps = {
    message: '',
    classes: ''
}

export { VoidState };
